module.exports = __webpack_public_path__ + "media/images/navbar/right-arrow-icon-94e3534c13a28539a5877f418317604c.svg";